import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import ScrollToTop from "./components/feature/ScrollToTop";
import { useAnalyticsTracking } from "./hooks/useAnalyticsTracking";
import { useTrafficTracking } from "./hooks/useTrafficTracking";

function AnalyticsTracker() {
  useAnalyticsTracking();
  useTrafficTracking();
  return null;
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <ScrollToTop />
        <AnalyticsTracker />
        <AppRoutes />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
